// Note that these string values are used to categorize Sentry errors (see lib/util/monitoring)
// Do not change the string values!
export enum Environment {
  LOCAL = 'local',
  STAGING = 'staging',
  TESTING = 'testing',
  CYPRESS_TEST = 'cypress_test',
  EPHEMERAL = 'ephemeral',
  PRODUCTION = 'production',
  UNKNOWN = 'unknown',
}
